/* eslint-disable @typescript-eslint/indent */
import styled from 'styled-components';

import { ThemeProp } from '~/theme/Themes';

export const FileCard = styled.div<{ $failed?: boolean }>`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.5rem 0.75rem;
  border-radius: 0.5rem;
  border: 1px solid
    ${(props: ThemeProp & { $failed?: boolean }) =>
      props.$failed ? props.theme.colors.system.error.c500 : props.theme.colors.neutrals.c100};
  background: ${(props: ThemeProp) => props.theme.colors.neutrals.white};
`;

export const FileName = styled.div`
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: ${(props: ThemeProp) => props.theme.fontSize.s};
  color: ${(props: ThemeProp) => props.theme.colors.neutrals.black};
`;

export const FileText = styled.div`
  flex: 1;
  min-width: 0;
`;

export const FileStatus = styled.div`
  font-size: ${(props: ThemeProp) => props.theme.fontSize.xs};
  color: ${(props: ThemeProp) => props.theme.colors.neutrals.c400};
`;

export const ChipButton = styled.button`
  border: none;
  background: none;
  padding: 0.125rem;
  cursor: pointer;
  font-size: ${(props: ThemeProp) => props.theme.fontSize.xs};
  color: ${(props: ThemeProp) => props.theme.colors.primary.c500};
  stroke: ${(props: ThemeProp) => props.theme.colors.neutrals.c400};
`;

export const AttachmentError = styled.div`
  font-size: ${(props: ThemeProp) => props.theme.fontSize.xs};
  color: ${(props: ThemeProp) => props.theme.colors.system.error.c500};
`;

export const PlusMenu = styled.div`
  position: absolute;
  bottom: 2.5rem;
  left: 0.75rem;
  z-index: 10;
  display: flex;
  flex-direction: column;
  min-width: 10rem;
  padding: 0.25rem;
  border-radius: 0.5rem;
  border: 1px solid ${(props: ThemeProp) => props.theme.colors.neutrals.c100};
  background: ${(props: ThemeProp) => props.theme.colors.neutrals.white};
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
`;

export const PlusMenuItem = styled.button`
  border: none;
  background: none;
  padding: 0.5rem 0.75rem;
  border-radius: 0.375rem;
  text-align: left;
  cursor: pointer;
  font-size: ${(props: ThemeProp) => props.theme.fontSize.s};
  color: ${(props: ThemeProp) => props.theme.colors.neutrals.black};

  &:hover {
    background: ${(props: ThemeProp) => props.theme.colors.neutrals.c050};
  }
`;

export const DropOverlay = styled.div`
  position: absolute;
  inset: 0.5rem;
  z-index: 20;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px dashed ${(props: ThemeProp) => props.theme.colors.primary.c500};
  border-radius: 0.75rem;
  background: rgba(255, 255, 255, 0.85);
  pointer-events: none;
  font-size: ${(props: ThemeProp) => props.theme.fontSize.s};
  color: ${(props: ThemeProp) => props.theme.colors.primary.c500};
`;

// In a user bubble, above the message text when there is one
export const SentFileCardContainer = styled(FileCard)`
  margin-bottom: 0.5rem;

  &:last-child {
    margin-bottom: 0;
  }
`;
/* eslint-enable @typescript-eslint/indent */
